import React from 'react'
import { Col } from 'react-bootstrap'

const ReusableHopCategory = ({img}) => {
  return (
    <Col lg={4} xs={6}>
            <div class="hop_category_main">
                                            <div class="hop_category_img">
                                                <img src= {img} class="w-100" alt=""/>
                                                <div class="hop_category_img_overlaay">
                                                    <div class="icon"><i class="fa-regular fa-heart"></i></div>
                                                    <div class="icon"><i class="fa-solid fa-magnifying-glass"></i></div>
                                                    <div class="icon"><i class="fa-solid fa-arrow-right-arrow-left"></i></div>
                                                    <div class="icon"><i class="fa-solid fa-cart-shopping"></i></div>
                                                 </div>
                                            </div>
                                        </div>
    </Col>
  )
}

export default ReusableHopCategory